/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeleteStockupItem200ResponseAllOfData } from './DeleteStockupItem200ResponseAllOfData';
import {
    DeleteStockupItem200ResponseAllOfDataFromJSON,
    DeleteStockupItem200ResponseAllOfDataFromJSONTyped,
    DeleteStockupItem200ResponseAllOfDataToJSON,
} from './DeleteStockupItem200ResponseAllOfData';

/**
 * 
 * @export
 * @interface DeleteStockupItem200Response
 */
export interface DeleteStockupItem200Response {
    /**
     * 
     * @type {DeleteStockupItem200ResponseAllOfData}
     * @memberof DeleteStockupItem200Response
     */
    data: DeleteStockupItem200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof DeleteStockupItem200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the DeleteStockupItem200Response interface.
 */
export function instanceOfDeleteStockupItem200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function DeleteStockupItem200ResponseFromJSON(json: any): DeleteStockupItem200Response {
    return DeleteStockupItem200ResponseFromJSONTyped(json, false);
}

export function DeleteStockupItem200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteStockupItem200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': DeleteStockupItem200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function DeleteStockupItem200ResponseToJSON(value?: DeleteStockupItem200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': DeleteStockupItem200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

